import React, { useState, useEffect } from 'react';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import './form.css'; // Import the updated CSS file
import FormAside from './FormAside';
import FormNotification from './FormNotification';
import SalesperformanceDashboard from './SalesperformanceDashboard';
import FollowUp from './Followup';
import MOUProcess from './MOUProcess';
import Centralisation from './Centralisation';
import UpcomingPaymentDates from './UpcomingPaymentDates';
import Approvalmainpage from './Approvalmainpage';

function FormPage() {
  const [empId, setEmpId] = useState('');
  const [empName, setEmpName] = useState('');
  const [designation, setDesignation] = useState('');
  const navigate = useNavigate(); // For navigation after logout


  // Effect to load employee details from localStorage
  useEffect(() => {

    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');

    // If employee details are missing, show alert and navigate to homepage
    if (!storedEmpId || !storedEmpName || !storedDesignation) {
      alert('Session expired. Please log in again.');
      navigate('/'); // Navigate to homepage (not necessarily the login page)
    } else {
      setEmpId(storedEmpId);
      setEmpName(storedEmpName);
      setDesignation(storedDesignation);
    }
  }, [navigate]);

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem('empId');
    localStorage.removeItem('empName');
    localStorage.removeItem('designation');
    navigate('/'); // Redirect to homepage after logout
  };

  return (
    <div className="form-page-container">
      <FormNotification />
      <FormAside />
     
      {/* Logout Button */}
      {/* <div className="logout-container">
        <button onClick={handleLogout} className="unique-form-button">
          Logout
        </button>
      </div> */}

      {/* Buttons for navigation */}
      {/* <div className="button-container">
        <Link to="/salesPerformance" state={{ empId, empName, designation }}> 
          <button>Sales Performance</button>
        </Link>
        <Link to="/followup" state={{ empId, empName, designation }}>
          <button>Follow-up</button>
        </Link>
        <Link to="/MOUProcess" state={{ empId, empName, designation }}>
          <button>MOU Process</button>
        </Link>
        <Link to="/Centralisation" state={{ empId, empName, designation }}>
          <button>Centralisation</button>
        </Link>
        <Link to="/UpcomingPaymentDates" state={{ empId, empName, designation }}>
          <button>Upcoming PaymentDates
          </button>
        </Link>
        <Link to="/Approvalmainpage" state={{ empId, empName, designation }}>
          <button>Expenses</button>
        </Link>
        <Link to="/Leaveportal" state={{ empId, empName, designation }}>
          <button>Leave Portal</button>

        </Link>
      </div> */}
      {/* Routes in form page */}
      <Routes>
        <Route path="/Salesperformance" element={<SalesperformanceDashboard />} />
        <Route path="/Followup" element={<FollowUp />} />
        <Route path="/MOUProcess" element={<MOUProcess />} />
        
        <Route path="/Centralisation" element={<Centralisation />} />
        <Route path="/UpcomingPaymentDates" element={<UpcomingPaymentDates />} />
        <Route path="/Approvalmainpage/*" element={<Approvalmainpage />} />
      </Routes>


    </div>
  );
}

export default FormPage;
